module.exports = __webpack_public_path__ + "8938518a3a50e8b47369f2c4f6bfcd8e.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/search-icon-purple.png
// module id = ./app/images/search-icon-purple.png
// module chunks = 3